(function () {
  var root = document.querySelector('[data-sova-pdp]');
  if (!root) return;

  /* ---------- Gallery ---------- */
  var mainImg = root.querySelector('[data-sova-gallery-main]');
  root.querySelectorAll('[data-sova-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-sova-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------- Variant + bundle pricing ---------- */
  var dataEl = document.querySelector('[data-sova-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-sova-option]'));
  var variantIdInput = root.querySelector('[data-sova-variant-id]');
  var quantityInput = root.querySelector('[data-sova-quantity]');
  var priceEl = root.querySelector('[data-sova-price]');
  var compareEl = root.querySelector('[data-sova-compare]');
  var atc = root.querySelector('[data-sova-atc]');
  var atcTotal = root.querySelector('[data-sova-atc-total]');
  var bundleLabels = Array.prototype.slice.call(root.querySelectorAll('[data-sova-bundle]'));
  var stockEl = root.querySelector('[data-sova-stock]');
  var stockMsgEl = root.querySelector('[data-sova-stock-message]');
  var stockThreshold = stockEl ? parseInt(stockEl.getAttribute('data-threshold'), 10) || 0 : 0;
  var stockMode = stockEl ? stockEl.getAttribute('data-mode') : 'low_only';
  var stockTextCount = stockEl ? stockEl.getAttribute('data-text-count') || '' : '';
  var stockTextGeneric = stockEl ? stockEl.getAttribute('data-text-generic') || '' : '';

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

  function formatMoney(cents) {
    if (window.SovaMoney) return window.SovaMoney.format(cents, moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function currentVariant() {
    if (!selects.length) return variants[0];
    var chosen = selects.map(function (s) { return s.value; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < chosen.length; j++) {
        if (v.options[j] !== chosen[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function selectedQuantity() {
    var checked = root.querySelector('[data-sova-bundle-input]:checked');
    return checked ? parseInt(checked.value, 10) || 1 : 1;
  }

  function update() {
    var v = currentVariant();
    var qty = selectedQuantity();

    if (quantityInput) quantityInput.value = qty;

    if (!v) {
      if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
      return;
    }

    if (variantIdInput) variantIdInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);

    /* Stock banner follows the selected variant */
    if (stockEl) {
      var tracked = v.inventory_management === 'shopify';
      var stockQty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
      var hasCount = tracked && stockQty !== null && stockQty > 0;
      var isLow = hasCount && stockQty <= stockThreshold;

      stockEl.hidden = !(stockMode === 'always' || isLow);

      if (!stockEl.hidden && stockMsgEl) {
        if (hasCount) {
          stockMsgEl.innerHTML = escapeHtml(stockTextCount)
            .replace('[count]', '<strong>' + stockQty + '</strong>');
        } else {
          stockMsgEl.textContent = stockTextGeneric;
        }
      }
    }

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    bundleLabels.forEach(function (label) {
      var input = label.querySelector('[data-sova-bundle-input]');
      var totalEl = label.querySelector('[data-sova-bundle-total]');
      var q = input ? parseInt(input.value, 10) || 1 : 1;
      if (totalEl) totalEl.textContent = formatMoney(v.price * q);
      label.classList.toggle('is-selected', !!(input && input.checked));
    });

    if (atc) {
      atc.disabled = !v.available;
      if (!v.available) {
        atc.textContent = 'Sold Out';
      } else if (atcTotal) {
        atcTotal.textContent = formatMoney(v.price * qty);
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  root.querySelectorAll('[data-sova-bundle-input]').forEach(function (input) {
    input.addEventListener('change', update);
  });

  update();
})();
